<template>
  <div v-if="isShow" class="modal-container">
    <div class="modal-dialog modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">{{ pageType }} Asset Category Attribute</h4>
          <a class="modal-close" @click="isShow = false"><i class="fa fa-times"></i></a>
        </div>
        <div class="modal-body" style="max-height: 600px; overflow: auto; overflow-x: hidden">
          <div class="container-fluid">
            <Form>
              <template v-for="(item, hindex) of formControlList" :key="item.id">
                <div v-if="item.group_display_name != 'System Information'">
                  <!-- <div v-if="hindex == 0" class="form-group col-sm-12">
                    <h4>{{ item.group_display_name }}</h4>
                  </div>
                  <div v-else class="form-group col-sm-12 mt-4">
                    <h4>{{ item.group_display_name }}</h4>
                  </div> -->
                  <!-- <h3 class="heading-partition">
                    {{ item.group_display_name }}
                  </h3> -->
                  <div class="row row align-items-center">
                    <template v-for="inner of item.InnerData" :key="inner.id">
                      <div class="col-6">
                        <!-- <div :class="{
                                                'col-sm-12 col-md-12 float-left': true, 'col-12': inner.layout_type == 'single', 'col-md-6': inner.layout_type == 'double', 'col-lg-4': inner.layout_type == 'triple', 'col-lg-3 col-xl-3':
                                                    inner.layout_type == 'four'
                                                }"> -->
                        <input type="hidden" v-if="inner.form_field_visibility == 'NO'" />
                        <label v-if="inner.form_field_visibility == 'YES' ||
                          inner.edit_form_field_visibility == 'YES'
                        ">{{ inner.display_name }}:<span class="text-danger" :class="{
  'text-danger': inner.is_required == true,
}" v-if="inner.is_required == true">*</span></label>
                        <div class="form-group" v-if="inner.form_field_visibility == 'YES' ||
                          inner.edit_form_field_visibility == 'YES'
                        ">
                          <template v-if="inner.dt_code == 'imageurl'">
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <div class="profile_upload_thumb">
                                  <img :src="inner.value" alt="img" class="upload_image_thnumb" @click="IsZoomProfile
                                    ? (IsZoomProfile = false)
                                    : (IsZoomProfile = true)
                                  " />
                                </div>
                              </div>
                              <div id="profile_thumb_upload" class="custom-file profile-pwt">
                                <input class="form-control" type="file" ref="file" @change="setFile"
                                  :readonly="inner.is_readOnly" :disabled="inner.is_readOnly"
                                  accept="image/x-png,image/gif,image/jpeg" lang="es" />
                              </div>
                            </div>
                          </template>

                          <input :class="{
                            'is-invalid':
                              inner.is_required &&
                              v$.value[inner.form_controlName].$invalid &&
                              v$.value[inner.form_controlName].$dirty,
                          }" type="text" class="form-control" :readonly="inner.is_readOnly"
                            v-model="fieldData[inner.form_controlName]" :id="inner.custom_field_id" v-if="inner.picklist_options != 'Lookup' &&
                              inner.dt_code != 'datetime' &&
                              inner.dt_code != 'date' &&
                              inner.dt_code != 'radio' &&
                              inner.dt_code != 'boolean' &&
                              inner.dt_code != 'select' &&
                              inner.dt_code != 'textarea' &&
                              inner.dt_code != 'checkbox' &&
                              inner.dt_code != 'date' &&
                              inner.dt_code != 'int' &&
                              inner.dt_code != 'decimal' &&
                              inner.dt_code != 'bigint' &&
                              inner.dt_code != 'imageurl'
                            " />
                          <template v-if="inner.dt_code == 'datetime'">
                            <Calendar v-model="fieldData[inner.form_controlName]" :id="inner.custom_field_id" showIcon
                              showTime hourFormat="12" :readonly="inner.is_readOnly" :class="{
                                'p-invalid':
                                  inner.is_required &&
                                  v$.value[inner.form_controlName].$invalid &&
                                  v$.value[inner.form_controlName].$dirty,
                              }" />
                          </template>

                          <template v-if="inner.dt_code == 'date'">
                            <Calendar v-model="fieldData[inner.form_controlName]" :id="inner.custom_field_id" showIcon
                              :readonly="inner.is_readOnly" :class="{
                                'p-invalid':
                                  inner.is_required &&
                                  v$.value[inner.form_controlName].$invalid &&
                                  v$.value[inner.form_controlName].$dirty,
                              }" />
                          </template>

                          <template v-if="inner.dt_code == 'select' &&
                            inner.ColumnName != 'Icon'
                          ">
                            <template v-if="inner.is_system_generated">
                              <Dropdown :class="{
                                'p-invalid':
                                  inner.is_required &&
                                  v$.value[inner.form_controlName].$invalid &&
                                  v$.value[inner.form_controlName].$dirty,
                              }" v-model="fieldData[inner.form_controlName]" :options="inner.select_options"
                                optionLabel="text" optionValue="value" :placeholder="'Select ' + inner.display_name"
                                class="p-dropdown-items-container-custom widthAll w-100" :filter="true" :showClear="true" />
                            </template>
                            <template v-if="!inner.is_system_generated">
                              <Dropdown :class="{
                                'p-invalid':
                                  inner.is_required &&
                                  v$.value[inner.form_controlName].$invalid &&
                                  v$.value[inner.form_controlName].$dirty,
                              }" v-model="fieldData[inner.form_controlName]" :options="inner.select_options"
                                optionLabel="name" optionValue="value" :placeholder="'Select ' + inner.display_name"
                                class="p-dropdown-items-container-custom widthAll w-100" :filter="true" :showClear="true" />
                            </template>
                          </template>

                          <template v-if="inner.dt_code == 'select'">
                            <template v-if="inner.ColumnName == 'Icon'">
                              <button v-if="hideChooseIconbtn == false" type="button"
                                class="btn btn-success mx-1 px-4 text-white" @click="isIconModalOpen = true">
                                <i class="fa fa-flag pr-1" aria-hidden="true"></i>
                                Choose Icon
                              </button>

                              <span v-if="isshowicon && inner.ColumnName == 'Icon'" class="icon-ininput">
                                <input type="text" class="form-control" :readonly="inner.is_readOnly"
                                  v-model="fieldData[inner.form_controlName]" :id="inner.custom_field_id"
                                  @click="isIconModalOpen = true" :class="{
                                    'is-invalid':
                                      inner.is_required &&
                                      v$.value[inner.form_controlName].$invalid &&
                                      v$.value[inner.form_controlName].$dirty,
                                  }" v-if="inner.ColumnName == 'Icon' && hideChooseIconbtn == true" />
                                <a class="input-group-text bg-white border-0 p-0" @click="clearSelectedIcon(fileInput)"
                                  style="position: absolute; z-index: 10; right :1px; padding: 8px 6px !important; color: #d00b05 !important; top: 1px; cursor: pointer;">
                                  <!-- <i class="feather-repeat"></i> -->
                                  <vue-feather type="repeat" size="18"></vue-feather>
                                </a>

                                <i style="position: absolute; top: 10px; left: 10px;"
                                  v-if="isshowicon && inner.ColumnName == 'Icon'" :class="icontoShow"></i>

                              </span>


                              <!-- <button @click="isIconModalOpen = true"
                v-if="inner.ColumnName == 'Icon'"
                class="btn btn-success text-white"> <i class="fa fa-flag pr-1"
                aria-hidden="true"></i> Choose
                Icon</button> -->
                              <!-- <span v-if="isshowicon && inner.ColumnName == 'Icon'" class="icon-ininput">
                <input type="text" class="form-control" :readonly="inner.is_readOnly"
                :formControlName="inner.form_controlName" :id="inner.custom_field_id"
                @click="showIconPopup()"
                v-if="inner.ColumnName == 'Icon' && hideChooseIconbtn==true" />
                <a class="input-group-text bg-white border-0 p-0"
                @click="clearSelectedIcon(fileInput)"
                style="position: absolute; z-index: 10; right :1px; padding: 8px 6px !important;    color: #d00b05 !important; top: 1px;    cursor: pointer;"><i
                class="feather-repeat"></i></a>

                <i v-if="isshowicon && inner.ColumnName == 'IconUpload'"
                class="{{icontoShow}} selectedico"></i>

                 </span> -->
                            </template>
                          </template>

                          <input type="number" class="form-control" :readonly="inner.is_readOnly" min="0" step="1"
                            v-model="fieldData[inner.form_controlName]" :id="inner.custom_field_id"
                            v-if="inner.dt_code == 'int'" />

                          <input type="number" class="form-control" :readonly="inner.is_readOnly" min="0" step="1"
                            v-model="fieldData[inner.form_controlName]" :id="inner.custom_field_id"
                            v-if="inner.dt_code == 'bigint'" />

                          <input type="number" class="form-control" :readonly="inner.is_readOnly"
                            pattern="^\d*(\.\d{0,2})?$" min="0" step="0.01" v-model="fieldData[inner.form_controlName]"
                            :id="inner.custom_field_id" v-if="inner.dt_code == 'decimal'" />

                          <textarea class="form-control" v-if="inner.dt_code == 'textarea'"
                            v-model="fieldData[inner.form_controlName]" rows="3" :readonly="inner.is_readOnly"
                            cols="4"></textarea>

                          <template v-if="inner.dt_code == 'checkbox'">
                            <div class="clearfix"></div>
                            <div class="custom-control custom-checkbox">
                              <input class="form-check-input" type="checkbox" v-model="fieldData[inner.form_controlName]"
                                required id="bool{{iy}}" />
                              <label class="form-check-label" for="chk_{{inner.custom_field_id}}_{{option}}_{{index}}">
                                {{ inner.picklist_options }}
                              </label>
                            </div>
                          </template>

                          <template v-if="inner.dt_code == 'boolean'">
                            <div class="form-check  form-check-inline">
                              <div class="custom-control custom-checkbox pl-0">
                                <label class="switch">
                                  <input type="checkbox" :id="inner.form_controlName"
                                    v-model="fieldData[inner.form_controlName]" />
                                  <span class="slider round" :id="inner.form_controlName"><span>Yes</span></span>
                                </label>
                              </div>
                            </div>
                          </template>

                          <!--Radio button-->
                          <template v-if="inner.dt_code == 'radio'">
                            <div v-for="options of inner.listoptions" :key="options.id">
                              <div class="custom-control custom-radio mx-2 p-0">
                                <input id="radio-{{inner.custom_field_id}}_{{options}}"
                                  v-model="fieldData[inner.form_controlName]" :value="options" type="radio" />
                                <label for="radio-{{inner.custom_field_id}}_{{options}}" class="radio-label">
                                  {{
                                    option
                                  }}
                                </label>
                              </div>
                            </div>
                          </template>
                          <span class="text-danger" v-if="inner.is_required &&
                            v$.value[inner.form_controlName].$invalid &&
                            v$.value[inner.form_controlName].$dirty
                          ">
                            {{ inner.display_name }} is required
                          </span>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </template>
            </Form>
          </div>

        </div>
        <div class="border-top">
          <div class="form-btn mb-3 ms-4">
            <a href="javascript:;" class="btn btn-pill btn-gradient color-4" @click="onSubmit()">Submit</a>
            <a href="javascript:;" class="btn btn-pill btn-dashed color-4" @click="cancel()">Cancel</a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div v-if="isIconModalOpen" class="modal-container">
    <CategoryAttributeIcon @CloseOrOpenIconModal="closeIconPopup" :isIconModalOpen="isIconModalOpen"
      @SubmitIcon="getIconvalue" />
  </div>

  <Loading v-model:active="isLoading">
    </Loading>
</template>
<script>
import Calendar from "primevue/calendar";
import { ref, onMounted, computed, getCurrentInstance } from "vue";
import { useRouter, useRoute } from "vue-router";
import CommonService from "@/service/crmservice/commonService";
import * as Yup from "yup";
import { Form, Field, useField } from "vee-validate";
import Dropdown from "primevue/dropdown";
import AssetCategoryService from "@/service/crmservice/assetcategoryservice";
import { createToaster } from "@meforma/vue-toaster";
import { required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
// import CategoryAttributeIcon from "./catgegoryattributeicon.vue";
import CategoryAttributeIcon from "../shared/categoryattributeicon.vue";

export default {
  name: "addeditassetcategoryattribute",
  components: {
    Form,
    Field,
    Dropdown,
    Calendar,
    CategoryAttributeIcon,
  },
  props: {
    primarykey: Yup.string,
    assetCategoryId: Yup.string,
  },
  setup(props, context) {
    const toaster = createToaster({ position: "top-right" });
    const thisApp = getCurrentInstance();
    const filters = thisApp.appContext.config.globalProperties.$filters;
    const assetCategoryService = ref(new AssetCategoryService());
    const commonService = ref(new CommonService());
    const route = useRoute();
    const isShow = ref(false);
    const primaryKeyAttr = ref(props.primarykey);
    const userId = ref(null);
    const companyId = ref(null);
    const moduleCode = ref("6002");
    const subModuleCode = ref("6002");
    const otherData = ref(null);
    const refId = ref(null);
    const displayCode = ref("Add");
    const isFor = ref(null);
    const deviceType = ref("Desktop");
    const layoutType = ref("Add");
    const assetcategoryId = ref(props.assetCategoryId);
    const listIcons = ref(null);
    const iconref = ref(false);
    const isIconModalOpen = ref(false);
    const hideChooseIconbtn = ref(false);
    const isshowicon = ref(false);
    const icontoShow = ref(null);

    const formControlList = ref([]);
    const checkboxdata1 = ref([]);
    const customFields = ref(null);
    const fieldData = ref({});
    const pageType = computed(() => {
      if (primaryKeyAttr.value == "" || primaryKeyAttr.value == undefined) {
        return "Add";
      } else {

        return "Edit";
      }
    });

    const isLoading = ref(false);

    const getUserInfo = () => {
      userId.value = localStorage.getItem("userId");
      companyId.value = localStorage.getItem("companyId");
    };

    const show = (primaryKey) => {
      isShow.value = true;
      primaryKeyAttr.value = primaryKey;
      getCustomFieldsData();
    };


    const showIconModal = (id) => {
      isIconModalOpen.value = true;
    };

    const closeIconPopup = () => {
      isIconModalOpen.value = false;
    };

    const cancel = () => {
      console.log("Cancel button is clicked");
      isShow.value = false;
      isshowicon.value = false;
      hideChooseIconbtn.value = false;
    }

    const clearSelectedIcon = () => {
      customFields.value.forEach((s) => {
        if (s.ColumnName == "Icon") {
          fieldData.value[s.form_controlName] = null;
        }
      })
      icontoShow.value = null;
      isshowicon.value = false;
      hideChooseIconbtn.value = false;
    }

    const getIconvalue = (event) => {
      isIconModalOpen.value = false;
      hideChooseIconbtn.value = true;
      isshowicon.value = true;
      icontoShow.value = event[0].text;
      customFields.value.forEach((s) => {
        if (s.ColumnName == "Icon") {
          fieldData.value[s.form_controlName] = event[0].value;
        }
      })
    }

    const onSubmit = async () => {
      isLoading.value = true;
      v$.value.value.$validate(); // checks all inputs
      if (v$.value.value.$error) {
        v$.value.value.$touch;
        isLoading.value = false;
        window.scrollTo(500, 0);
        return false;
      } else {
        var nameGiven = null;
        customFields.value.forEach((cnt) => {
          if (cnt.ColumnName == "Name") {
            nameGiven = fieldData.value[cnt.form_controlName];
          }
          if (pageType.value === "Edit" && cnt.ColumnName === "Description") {
            if (fieldData.value[cnt.form_controlName] && fieldData.value[cnt.form_controlName] != '') {
              let description = fieldData.value[cnt.form_controlName];
              fieldData.value[cnt.form_controlName] = description.replace(/'/g, "''");
            }
          }
        });
        let duplicateObj = {
          Id: primaryKeyAttr.value == undefined ? null : primaryKeyAttr.value,
          PrimaryId: 'null',
          name: nameGiven,
          subModule: subModuleCode.value,
          type: "AssetCategoryAttribute",
          companyId: companyId.value,
          userId: userId.value
        }
        console.log(duplicateObj);
        await commonService.value
          .CheckDuplicateCrm(duplicateObj)
          .then(async (responseDuplicate) => {
            if (responseDuplicate.data) {
              var dataModel = new JsonData();
              dataModel.Id = primaryKeyAttr.value;
              dataModel.ModuleCode = moduleCode.value;
              dataModel.SubModuleCode = subModuleCode.value;
              dataModel.CompanyId = companyId.value;
              dataModel.UserId = userId.value;
              var name = null;
              for (var prop in fieldData.value) {
                if (prop.includes("CreatedBy") || prop.includes("ModifiedBy")) {
                  fieldData.value[prop] = null;
                }
                if (prop.includes("Name")) {
                  name = fieldData.value[prop];
                }
              }
              dataModel.FormJsonData = JSON.stringify(fieldData.value);
              dataModel.assetCategoryId = assetcategoryId.value;
              await assetCategoryService.value
                .addEditAssetCategoryAttribute(dataModel)
                .then((response) => {
                  if (response.data.statusCode == 200) {
                    toaster.success(
                      `Attribute "${name}"` + response.data.responseMessage
                    );
                    isshowicon.value = false;
                    hideChooseIconbtn.value = false;
                    setTimeout(() => {
                      isLoading.value = false;
                    }, 500);
                  } else {
                    isLoading.value = false;
                    toaster.error(response.data.responseMessage);
                  }
                })
                .catch((error) => {
                  isLoading.value = false;
                  console.log("error", error.response);
                });

              context.emit("refreshAttributeListing");
              isShow.value = false;
            } else {
              isLoading.value = false;
              toaster.error(
                `Asset category ${nameGiven} with same already exists.`
              );
            }
          });
      }
    };

    const getCustomFieldsData = () => {
      isLoading.value = true;
      commonService.value
        .getCustomFieldsData(
          primaryKeyAttr.value == undefined ? null : primaryKeyAttr.value,
          moduleCode.value,
          subModuleCode.value,
          otherData.value,
          refId.value,
          displayCode.value,
          companyId.value,
          userId.value,
          isFor.value,
          deviceType.value,
          layoutType.value
        )
        .then((response) => {
          console.log("Custom field response Data", response);
          formControlList.value = [];
          customFields.value = response.data.data;
          customFields.value.forEach((t) => {
            let groupCheck = formControlList.value.filter(
              (y) => y.group_id == t.group_id
            );

            if (t.dt_code == "radio") {
              t.listoptions = JSON.parse(t.listoptions);
            }
            if (t.dt_code == "checkbox") {
              t.listoptions = JSON.parse(t.listoptions);
              let checkdata = {
                controlname: t.form_controlName,
              };
              checkboxdata1.value.push(checkdata);
            }

            if (groupCheck == null || groupCheck.length == 0) {
              let obj = {
                group_id: t.group_id,
                group_name: t.group_name,
                group_display_name: t.group_display_name,
                InnerData: customFields.value.filter(
                  (x) => x.group_id == t.group_id
                ),
              };

              formControlList.value.push(obj);
            }
          });
          //const group = {};
          customFields.value.forEach((cnt) => {
            let val = null;
            if (cnt.actual_data_type == "bit") {
              val = cnt.value == 1 ? true : false;
            }
            else if (cnt.dt_code == 'datetime') {
              val = (cnt.value == '' ? null : filters.dateFormat(cnt.value)); // to convert to local time
            }
            else if (cnt.dt_code == 'date') {
              val = (cnt.value == '' ? null : filters.dateFormat(cnt.value)); // to convert to local time
            }
            else {
              val = cnt.value == "" ? null : cnt.value;
            }


            if (cnt.ColumnName == 'AttributeType') {
              cnt.is_required = true;
            }


            if (cnt.ColumnName == "Icon") {

              if (cnt.value) {
                listIcons.value = [];
                commonService.value
                  .GetMasterItemsNotAuth("Icons", userId.value, null)
                  .then((result) => {
                    isshowicon.value = true;
                    hideChooseIconbtn.value = true;
                    listIcons.value = result.data;
                    fieldData.value[cnt.form_controlName] = cnt.value;
                    icontoShow.value = listIcons.value.filter(x => x.value == cnt.value.toLowerCase())[0].text;

                  });
              }
            }

            checkboxdata1.value.forEach((item) => {
              if (cnt.form_controlName == item.controlname) {
                item.controlvalues = cnt.value;
              }
            }); //for checkboxes on form
            if (cnt.actual_data_type == "checkbox") {
              try {
                checkboxdata1.value.forEach((item) => {
                  // // console.log(item.controlname, item.controlvalues);
                  this.form
                    .get(item.controlname)
                    .setValue(item.controlvalues.split(","));
                });
              } catch (err) { }
            }
            fieldData.value[cnt.form_controlName] = val;
          });

          formControlList.value.forEach((x) => {
            x.InnerData.forEach((y) => {
              console.log("y:", y.is_required);
              if (y.is_required == true) {
                ruleObj.value[y.form_controlName] = {
                  required,
                  $autoDirty: true,
                };
              }
            });
          });
          rules.value = ruleObj.value;
          v$.value = useVuelidate(rules, fieldData.value);
          isLoading.value = false;
        });
    };

    const ruleObj = ref({});
    const rules = computed(() => ruleObj.value);
    const v$ = ref({});

    onMounted(() => {
      getUserInfo();
    });

    return {
      v$,
      commonService,
      isLoading,
      isShow,
      primaryKeyAttr,
      userId,
      companyId,
      moduleCode,
      subModuleCode,
      otherData,
      refId,
      displayCode,
      isFor,
      deviceType,
      layoutType,
      route,
      formControlList,
      checkboxdata1,
      customFields,
      fieldData,
      isShow,
      assetcategoryId,
      pageType,
      listIcons,
      isIconModalOpen,
      isshowicon,
      hideChooseIconbtn,
      icontoShow,
      show,
      onSubmit,
      getCustomFieldsData,
      getUserInfo,
      showIconModal,
      closeIconPopup,
      getIconvalue,
      clearSelectedIcon,
      cancel
    };
  },
};

export class JsonData {
  Id;
  FormJsonData;
  ModuleCode;
  SubModuleCode;
  CompanyId;
  UserId;
  assetCategoryId;
  constructor() {
    this.Id = null;
    this.FormJsonData = "";
    this.ModuleCode = "";
    this.SubModuleCode = "";
    this.CompanyId = "";
    this.UserId = "";
    this.assetCategoryId = "";
  }
}
</script>
<style>
.p-dropdown-items-wrapper {
  max-width: 100%;
}

.selectedico {
  position: absolute;
  top: 10px;
  left: 10px;
}
</style>
